module.exports = __webpack_public_path__ + "img/earth.20db3087.jpg";